import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid" }
const _hoisted_2 = { class: "col-4 stack" }

import { ref, computed } from 'vue';
	import { AnnualReviewDetails } from '@/models/loans';
	import { CreditPullTypes, AnnualReviewStatusTypes } from '@/types/annual-review';
	import Accordion from '@/components/shared/Accordion.vue';
	import DetailsCard from '@/components/loan/annual-review/DetailsCard.vue';
	import KeyDatesCard from '@/components/loan/annual-review/KeyDatesCard.vue';
	import CreditReportInformation from '@/components/loan/annual-review/CreditReportInformation.vue';
	import CourtesyRepullModal from '@/components/loan/annual-review/CourtesyRepullModal.vue';
	import RedecisionErrorModal from '@/components/loan/annual-review/RedecisionErrorModal.vue';
	import PermissionsWrapper from '@/components/wrappers/PermissionsWrapper.vue';
	import { Permissions, PermissionLevels } from '@/models/permissions';

	
export default /*@__PURE__*/_defineComponent({
  __name: 'AnnualReviewDetails',
  props: {
    loanId: {},
    lenderId: {},
    productTypeId: {},
    programTypeId: {},
    referenceId: {},
    applicationUrl: {},
    annualReviewDetails: {},
    selectedAnnualReviewId: {},
    onReloadAnnualReviewAsync: { type: Function }
  },
  setup(__props: any) {

	const props = __props;

	const viewingRepull = ref(false);
	const viewingRedecision = ref(false);

	const redecisionEnabled = computed(() => {
		const validStatuses = [AnnualReviewStatusTypes.DECISION_ERROR, AnnualReviewStatusTypes.CREDIT_ALERT];

		return validStatuses.includes(props.annualReviewDetails.annualReviewStatusId);
	});

	const closeRepullModal = () => (viewingRepull.value = false);
	const openRepullModal = () => (viewingRepull.value = true);

	const closeRedecisionModal = () => (viewingRedecision.value = false);
	const openRedecisionModal = () => (viewingRedecision.value = true);

return (_ctx: any,_cache: any) => {
  return (__props.annualReviewDetails)
    ? (_openBlock(), _createBlock(Accordion, {
        key: 0,
        label: "Annual Review Credit Report Details",
        isOpen: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(DetailsCard, {
                cardTitle: 'Annual Review Details',
                referenceId: __props.referenceId,
                applicationUrl: __props.applicationUrl,
                details: __props.annualReviewDetails,
                creditPullTypeId: _unref(CreditPullTypes).ORIGINAL,
                onReloadAnnualReviewAsync: __props.onReloadAnnualReviewAsync
              }, null, 8, ["referenceId", "applicationUrl", "details", "creditPullTypeId", "onReloadAnnualReviewAsync"]),
              _createVNode(PermissionsWrapper, {
                permissionIds: [_unref(Permissions).AnnualReview],
                permissionLevel: _unref(PermissionLevels).Update
              }, {
                default: _withCtx(() => [
                  (redecisionEnabled.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: openRedecisionModal
                      }, "Re-decision Error"))
                    : _createCommentVNode("", true),
                  (__props.annualReviewDetails.annualReviewStatusId === _unref(AnnualReviewStatusTypes).DECISION_ERROR)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        onClick: openRedecisionModal
                      }, " Re-decision Error "))
                    : (__props.annualReviewDetails.annualReviewStatusId === _unref(AnnualReviewStatusTypes).DECLINED)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          onClick: openRepullModal
                        }, " Courtesy Re-pull "))
                      : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["permissionIds", "permissionLevel"])
            ]),
            _createVNode(KeyDatesCard, {
              class: "col-3",
              batchedDate: __props.annualReviewDetails.batchedDateFormatted,
              creditPulledDate: __props.annualReviewDetails.creditPulledDateFormatted,
              initialStatusDate: __props.annualReviewDetails.initialStatusDateFormatted,
              finalStatusDate: __props.annualReviewDetails.finalStatusDateFormatted
            }, null, 8, ["batchedDate", "creditPulledDate", "initialStatusDate", "finalStatusDate"]),
            _createVNode(CreditReportInformation, {
              class: "col-12",
              loanId: __props.loanId,
              annualReviewId: __props.selectedAnnualReviewId,
              lenderId: __props.lenderId,
              programTypeId: __props.programTypeId,
              productTypeId: __props.productTypeId,
              applicationTypeId: __props.annualReviewDetails.applicationTypeId,
              creditPullTypeId: _unref(CreditPullTypes).ORIGINAL
            }, null, 8, ["loanId", "annualReviewId", "lenderId", "programTypeId", "productTypeId", "applicationTypeId", "creditPullTypeId"])
          ]),
          (viewingRedecision.value)
            ? (_openBlock(), _createBlock(RedecisionErrorModal, {
                key: 0,
                annualReviewId: __props.annualReviewDetails.id,
                annualReviewYear: __props.annualReviewDetails.annualReviewYear,
                loanId: __props.loanId,
                onClose: closeRedecisionModal
              }, null, 8, ["annualReviewId", "annualReviewYear", "loanId"]))
            : _createCommentVNode("", true),
          (viewingRepull.value)
            ? (_openBlock(), _createBlock(CourtesyRepullModal, {
                key: 1,
                annualReviewId: __props.annualReviewDetails.id,
                annualReviewYear: __props.annualReviewDetails.annualReviewYear,
                loanId: __props.loanId,
                onClose: closeRepullModal
              }, null, 8, ["annualReviewId", "annualReviewYear", "loanId"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})